var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 5939"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13037_1596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1774",
    y: 0.5,
    width: 33,
    height: 39,
    rx: 1.5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1776",
    y: 0.5,
    width: 16.5,
    height: 9,
    fill: "#3248CA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1780",
    x: 16.5,
    y: 0.5,
    width: 16.5,
    height: 9,
    fill: "#4F65E6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1777",
    y: 9.5,
    width: 16.5,
    height: 10.5,
    fill: "#1E34B7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1781",
    x: 16.5,
    y: 9.5,
    width: 16.5,
    height: 10.5,
    fill: "#3248CA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1778",
    y: 20,
    width: 16.5,
    height: 9,
    fill: "#00169D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1782",
    x: 16.5,
    y: 20,
    width: 16.5,
    height: 9,
    fill: "#1E34B7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1779",
    y: 29,
    width: 16.5,
    height: 10.5,
    fill: "#00169D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1783",
    x: 16.5,
    y: 29,
    width: 16.5,
    height: 10.5,
    fill: "#00169D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13037_1596"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 33,
    height: 39,
    rx: 1.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.e9647621a8202835d6c5e67dc36be96e.svg";
export { ForwardRef as ReactComponent };